import React from "react";
import "../../../css/blogs.css"; // Import the CSS file

const getCategoryClassName = (category) => {
  const classMap = {
    influencer: "category-badge-influencer",
    "social-media": "category-badge-social-media",
    business: "category-badge-business",
    marketing: "category-badge-marketing",
    "case-study": "category-badge-case-study",
    "digital-growth": "category-badge-digital-growth",
    default: "category-badge-default",
  };

  return classMap[category] || classMap.default;
};

const formatCategoryName = (category) => {
  if (!category) return "";
  return category
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const CategoryBadge = ({ category, className = "", style }) => {
  const categoryClassName = getCategoryClassName(category);

  return (
    <span
      className={`category-badge ${categoryClassName} ${className}`.trim()}
      style={style} // Allow inline style overrides if needed
    >
      {formatCategoryName(category)}
    </span>
  );
};
